module.exports = __webpack_public_path__ + "img/wechartShare.5cd5427d.png";